import axios from "axios";
import {Loader} from '@googlemaps/js-api-loader';


export const useMapCommon = () => {
  /**
   * create a location object
   */
  function toLocation(id, name) {
    return { "locationId": id, "locationName": name }
  }

  /**
   * fetch data from a url and wrangle it into a list of objects
   * @param url url to fetch array data from
   * @param wrangler function to map one item to one Location object {locationId: 'x', locationName: 'y'}
   */
  async function urlToLocations(url, wrangler) {
    try {
      let response = await axios.get(url, { withCredentials: false })
      let locations = response.data.map(wrangler)
      return locations
    } catch(error) {
      console.error(`Failed to fetch from ${url}:`, error)
    }
  }

  const fetchLocation = async (locationId) => {
    let location = null;

    await axios.get(getLocationUrl(locationId), {withCredentials: false}).then(
      response => {
        location = response.data;
      });

    return location;
  }

  function getLocationUrl(locationId) {
    return '/map/locations/' + locationId;
  }

  const stringLatLngToNumberLatLng = (latLng) => {
    const lat = Number(latLng.lat);
    const lng = Number(latLng.lng);

    return {lat: lat, lng: lng};
  }

  // load google maps api
  const googleApiLoader = new Loader({
    apiKey: "AIzaSyBrOp6Lf34nrawOcrqm-1705cL6EeeDliQ",
    version: 'weekly',
    libraries: ['marker'],
  });

  const googleApiPromise = googleApiLoader.load();

  const urlQueryPersist = (url, route) => {

    const PERSISTENT_PARAMS = ['features', 'showAccessibleRoutes']

    const persisted = PERSISTENT_PARAMS
      .filter(key => route.query[key] !== undefined)
      .map(key => `${key}=${route.query[key]}`)
      .join('&')

    if (persisted) url += '&' + persisted


    return url
  }

  return {
    toLocation,
    urlToLocations,
    stringLatLngToNumberLatLng,
    fetchLocation,
    googleApiPromise,
    urlQueryPersist
  }
}
